import { sendGet, sendPost } from "./generic"

export const login = (payload) => {
    return sendPost(`Accounts/Login`, payload)
}

export const twoFactorAuth = (payload) => {
    return sendPost(`Accounts/LoginWith2fa`, payload)
}

export const logout = (payload) => {
    return sendPost(`Accounts/Logout`, payload)
}

export const getCurrentUser = () => {
    return sendGet(`Accounts/Current`)
}

export const updateUser = (payload) => {
    return sendPost(`Accounts/Profile`, payload)
}

export const refreshToken = (refreshToken) => {
    return sendPost("Accounts/Refresh", { refreshToken: refreshToken })
}
